import assetPath from '/app/xinglets/startpage-logged-out/entry/src/companies-section/assets/rossman-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')